import React from 'react';

var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const IcBookmarks = /* @__PURE__ */ __name((properties) => /* @__PURE__ */ React.createElement("svg", {
  fill: "none",
  height: "24",
  width: "24",
  xmlns: "http://www.w3.org/2000/svg",
  ...properties
}, /* @__PURE__ */ React.createElement("path", {
  d: "M5 4.361a1.5 1.5 0 0 1 1.5-1.5h11a1.5 1.5 0 0 1 1.5 1.5v2.5H5v-2.5Z",
  fill: "var(--mds-nav-icon-weak)"
}), /* @__PURE__ */ React.createElement("path", {
  d: "M5 8.861h14v11.277a1 1 0 0 1-1.496.868l-5.008-2.861a1 1 0 0 0-.992 0l-5.008 2.861A1 1 0 0 1 5 20.138V8.861Z",
  fill: "var(--mds-nav-icon-accent)"
})), "IcBookmarks");

export { IcBookmarks };
//# sourceMappingURL=ic-bookmarks.js.map
